import {Injectable, NgZone} from '@angular/core';
import Echo from 'laravel-echo';
import {AuthenticationService} from '../pages/authentication/authentication.service';
import {AppInitService} from './app-init.service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../environments/environment';
import {LocalStorageService} from './local-storage.service';
import {NotificationService} from './notification.service';
import {ShoppingCartService} from '../modules/shopping-cart/shopping-cart.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  constructor(private authService: AuthenticationService,
              private translateService: TranslateService,
              private localStorage: LocalStorageService,
              private snackBar: NotificationService,
              private shoppingCartService: ShoppingCartService,
              private ngZone: NgZone,
              private appInitService: AppInitService) {

    this.startEcho();
  }

  startEcho() {
    this.ngZone.runOutsideAngular(() => {
      const echoOptions = {
        broadcaster: 'socket.io',
        host: 'api.90fit.com.tr:6001', //
        forceNew: true,
        secure: true,
      };

      if (this.authService.loggedIn) {
        echoOptions['authEndpoint'] = environment.socketServiceHost + '/api/broadcasting/auth';
        echoOptions['namespace'] = 'Elma.Events';
        echoOptions['auth'] = {
          headers: {
            authorization: this.authService.auth.type + ' ' + this.authService.auth.token,
            lang: this.translateService.currentLang ?? 'tr',
            'Content-Type': 'application/vnd.example.v1+json',
            Accept: 'application/json',
            AppUuid: environment.appUuid
          }
        };
      }

      window.Echo = new Echo(echoOptions);

      if (this.authService.loggedIn) {
        this.listenPrivate();
      }

      // if (this.authService.loggedIn) {
      //   window.Echo = new Echo({
      //     broadcaster: 'socket.io',
      //     host: environment.socketServiceHost, // window.location.hostname
      //     authEndpoint: '/api/broadcasting/auth',
      //     namespace: 'Elma.Events',
      //     forceNew: true,
      //     auth: {
      //       headers: {
      //         authorization: this.authService.auth.type + ' ' + this.authService.auth.token,
      //         lang: `${this.translateService.currentLang ? this.translateService.currentLang : 'tr'}`,
      //         'Content-Type': `application/vnd.example.v1+json`,
      //         Accept: `application/json`,
      //         AppUuid: environment.appUuid
      //       }
      //     }
      //   });
      //   this.listenPrivate();
      // } else {
      //   window.Echo = new Echo({
      //     broadcaster: 'socket.io',
      //     host: environment.socketServiceHost,
      //     forceNew: true,
      //   });
      // }

      window.Echo.channel('system')
      .listen('.system', (data) => {
        console.log(data);
        this.appInitService.process(data.data, false);
      });
    });
  }

  listenPrivate() {
    window.Echo.private(`profile.${this.authService.auth.profile.id}`)
    .listen('.profile', (data) => {

      this.authService.user = data.data;
      if (data.message) {
        this.snackBar[data.message.type](data.message.message);
      }
    });

    window.Echo.private(`shoppingCart.${environment.appUuid}.${this.localStorage.getItem('system.session')}`)
    .listen('.shoppingCart', (data) => {
      this.shoppingCartService.shoppingCart$.next(data.data);
    });
  }
}
